import Header from "../../app/universalComponents/Header";
import Footer from "../../app/universalComponents/Footer";
import { useEffect } from "react";

const terms = [
    {
        title: "Age Restrictions and Alcohol",
        body: "In compliance with local laws, visitors below the age of 17 are not allowed to buy or sample alcoholic beverages. Events that include clubbing and alcoholic beverages require attendees to be of legal drinking age. Entry will be denied to those underage and tickets will not be refunded.",
    },
    {
        title: "Ticket Resale",
        body: "The resale of tickets for commercial benefit is not permitted. Should the Event Organiser suspect that tickets have been sold for such purposes, these may be invalidated, and the ticket holder may be denied entry.",
    },
    {
        title: "Ticket Validity",
        body: "A ticket in proper condition, unaltered and original, is necessary to gain admission to an Event. Tampering, modifying, or duplicating the ticket in any way may result in its invalidation.",
    },
    {
        title: "Filming, Photography, and Recording",
        body: "Attendees should be aware that they may be filmed, photographed, or audio-recorded for broadcasting, publishing, or security purposes during the Event by the Event Organiser, including sponsors and other partners authorised by the Event Organiser.",
    },
    {
        title: "Personal Belongings",
        body: "The Event Organiser does not assume responsibility for any loss or damage to personal belongings brought to the Event.",
    },
    {
        title: "Liability",
        body: "The Event Organiser is not liable for any loss, damage, death, or injury unless (i) the relevant party has breached its legal obligations; and (ii) the loss or damage is a direct and foreseeable consequence of the breach. To clarify, the Event Organiser will not be held accountable for the actions of any third party, such as exhibitors or performers.",
    },
    {
        title: "Security and Entry Checks",
        body: "For the safety of attendees, the Event Organiser maintains the right to deny entry and perform security checks as deemed necessary. Video and audio recording within performance and theatre areas of the Event are not permitted unless explicit written permission is granted by the Event Organiser.",
    },
    {
        title: "Postponement, Relocation, and Cancellation",
        body: "Should an Event be postponed or relocated, the Event Organiser will offer you the choice to either keep or exchange your tickets for the new date/location, or to obtain a refund. In case of an Event cancellation, you may have the option to transfer your tickets to a future event or receive a refund on your tickets. However, any associated Booking Fees and/or Transaction Fees are not eligible for a refund under such circumstances.",
    },
    {
        title: "Event Changes",
        body: "You acknowledge that the Event Organiser may, when needed, replace, add, or withdraw performers, adjust the advertised agenda, timing of the event, seating arrangements, and audience capacity without significantly altering the nature of the event. These changes may arise due to directives from relevant authorities, unavailability of performers, or any other circumstances beyond the control of the Event Organiser. These alterations shall not affect any potential rights you may have to a refund.",
    },
    {
        title: "Expenses Caused by Event Changes",
        body: "The Event Organiser is not liable for any expenses you may incur due to changes, postponements, relocations, or cancellations of the Event, including but not limited to travel, accommodation, and any other goods, services, or compensation.",
    },
    {
        title: "Outdoor Events and Weather",
        body: "Should an Event, in full or in part, be scheduled to take place outdoors, it will proceed irrespective of weather conditions unless deemed unsafe by the appointed safety officer. Efforts will be made to secure an alternative indoor venue if required, but no refunds will be issued due to poor weather if the Event takes place.",
    },
    {
        title: "Governing Law",
        body: "The relevant laws of Malta apply to these Terms and Conditions, and the Courts of Malta will have exclusive jurisdiction over any matters related to these Terms and Conditions.",
    },
];

export default function TermsPage() {

    useEffect(() => {
        document.title = "T&Cs | Tickets.NP";
    }, []);

    return (
        <>
            <a
                href="#main-content"
                className="sr-only focus:not-sr-only focus:absolute focus:left-4 focus:top-4 focus:z-50 focus:rounded-sm focus:bg-black focus:px-4 focus:py-2 focus:text-white"
            >
                Skip to main content
            </a>

            <Header sellTickets={true} />

            <main id="main-content" className="mx-6 py-10">
                <section
                    className="mx-auto max-w-4xl"
                    aria-labelledby="terms-title"
                >
                    <p className="text-sm font-semibold uppercase tracking-widest text-gray-600">
                        Legal
                    </p>

                    <h1
                        id="terms-title"
                        className="mt-2 text-4xl font-bold tracking-tight text-gray-950"
                    >
                        Terms and Conditions
                    </h1>

                    <p className="mt-4 max-w-3xl text-sm text-gray-500">
                        Please read these terms carefully before using Tickets.NP
                        or purchasing tickets through the platform.
                    </p>
                </section>

                <section
                    className="mx-auto mt-10 max-w-4xl"
                    aria-labelledby="terms-list-title"
                >
                    <h2 id="terms-list-title" className="sr-only">
                        Terms list
                    </h2>

                    <ol className="space-y-6">
                        {terms.map((term, index) => (
                            <li
                                key={term.title}
                                className="border border-gray-300 p-6 shadow-sm"
                            >
                                <article aria-labelledby={`term-${index}`}>
                                    <h3
                                        id={`term-${index}`}
                                        className="text-xl font-bold tracking-tight"
                                    >
                                        <span
                                            aria-hidden="true"
                                            className="mr-2"
                                        >
                                            {index + 1}.
                                        </span>
                                        {term.title}
                                    </h3>

                                    <p className="mt-3 text-base">
                                        {term.body}
                                    </p>
                                </article>
                            </li>
                        ))}
                    </ol>
                </section>
            </main>

            <Footer />
        </>
    );
}